export default class CollectorsController {
  constructor(ContentService, $uibModal, $state, Notification, $translate) { 
    this.service = ContentService;
    this.modal = $uibModal;
    this.state = $state;
    this.notify = Notification;
    this.trans = $translate.instant;
  }

  $onInit() {
    this.subscriptions = [];

    this.statuses = {
      COLLECTING: 'Colectando',
      STOPPED: 'Detenido'
    };
    this.collectors = [];
    this.posList = [];
    this.subscriptions.push(
      this.collectorsObservable.subscribe(collectorsList => this.collectors = collectorsList.collectors || [])
    );
    this.subscriptions.push(
      this.posObservable.subscribe(posList => this.posList = posList || [])
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  deleteCollector(collector, idx) {
    this.subscriptions.push(
      this.service.deleteCollector(collector).subscribe(
        () => { this.collectors.splice(idx, 1); }
      )
    );
  }

  startCollector(collector, idx){
    this.subscriptions.push(
      this.service.startCollector(collector).subscribe(
        () => { this.collectors[idx].status = 'COLLECTING' }
      )
    );
  }

  stopCollector(collector, idx){
    this.subscriptions.push(
      this.service.stopCollector(collector).subscribe(
        () => { this.collectors[idx].status = 'STOPPED' }
      )
    );
  }

  collect(collector){
    const _ = this.trans;
    this.subscriptions.push(
      this.service.collect(collector).subscribe(
        () => { this.notify.success(_('Datos colectados de manera exitosa.')) }
      )
    );
  }

  collectAll(){
    const _ = this.trans;
    this.subscriptions.push(
      this.service.collectAll().subscribe(
        () => { this.notify.success(_('Datos colectados de manera exitosa.')) }
      )
    );
  }

  openCollectorsModal(collector){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'collector-modal.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, $translate) => {
        "ngInject";
        const _ = $translate.instant;
        $scope.collector = collector || {};

        $scope.posList = that.posList.map(
          (pos) => {
            if ($scope.collector.hasOwnProperty('pos_list')){
              pos.observed = $scope.collector.pos_list.some(p => p.id === pos.id);
            } else {
              pos.observed = false;
            }
            pos.taken = that.collectors.filter(col => {
              if ($scope.collector){
                return $scope.collector.id != col.id;
              } else {
                return true;
              }
            }).filter(collector => 
               collector.pos_list.some(point => point.id === pos.id)
            ).length > 0
            return pos;
          }
        );
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.registerCollector = () => {
          $scope.collector.pos_list = $scope.posList.filter(pos => pos.observed && !pos.taken).map(pos => pos.id);
          that.subscriptions.push(
            that.service.registerCollector($scope.collector).subscribe(
              (newCollector) => {
                that.collectors.push(newCollector);
                $scope.closeThisDialog();
              }
            )
          );
        }
        $scope.editCollector = () => {
          that.subscriptions.push(
            that.service.editCollector($scope.collector).subscribe(
              (newCollector) => {
                $scope.closeThisDialog();
              }
            )
          );
        }
        $scope.togglePos = (pos, index) => {
          // TODO: Remove/Add from the current collector
          if (pos.observed) {
            that.subscriptions.push(
              that.service.observePOS($scope.collector, pos).subscribe((resp) => {
                if (!$scope.collector.pos_list) {
                  $scope.collector.pos_list = [];
                };
                $scope.collector.pos_list.push(pos);
                that.notify.success(_(`El colector estará ahora colectando datos del punto de venta seleccionado.`));
              })
            );
          } else {
            that.subscriptions.push(
              that.service.unobservePOS(collector, pos).subscribe(
                (resp) => {
                  $scope.collector.pos_list.splice($scope.collector.pos_list.indexOf(pos), 1);
                  that.notify.success(_(`${collector.name} ya no estará colectando datos de ${pos.name}.`));
                }
              )
            );
          }
        };
      }
    })
  }

}

 CollectorsController.$inject = ['ContentService', '$uibModal', '$state', 'Notification', '$translate'];



// WEBPACK FOOTER //
// ./src/app/pages/collectors/collectors.controller.js